import { createAction, props } from '@ngrx/store';

import { SystemConfigurationsMobileConfigResponse } from '../../typings/system-configurations';

export const loadConfig = createAction('[Config] Load');

export const loadConfigSuccess = createAction(
  '[Config] Load Success',
  props<{
    payload: SystemConfigurationsMobileConfigResponse;
  }>()
);

export const loadConfigFailure = createAction('[Config] Load Failure', props<{ payload: { error: string } }>());

export const loadConfigReset = createAction('[Config] Load Reset');
